/** Façade Angular : la priorité du prix affiché vit dans @befret/core. */
import { resolveShipmentDisplayPrice } from '@befret/core/pricing';
export function getDisplayPrice(shipment: any): number { return resolveShipmentDisplayPrice(shipment, 0) ?? 0; }
